import { gql } from "urql";
export const GetPublicPriorityEntryDetailsQuery = gql `
    query GetPublicPriorityEntryDetails($key1: String!, $key2: String!) {
        priorityEntries {
            publicPriorityEntryDetails(key1: $key1, key2: $key2) {
                organizationId
                name
                imageUrl
                isExpired
            }
        }
    }
`;
